import styled from 'styled-components/macro';

export const StyledDownloadTimes = styled.div`

`;
